import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';

export function useIsAdvanceDiagnosticsExamsJourney(bookingNumber?: string) {
	const isAdvanceDiagnosticsFlow = useBookingStore(
		state => state.bookingData.isAdvanceDiagnosticsFlow,
	);
	const storedBookingNumber = useBookingStore(state => state.bookingData.bookingNumber);
	const {isEnabled: isFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_ADVANCE_DIAGNOSTICS_EXAMS_JOURNEY,
	);

	const belongsToBooking =
		bookingNumber === undefined ||
		(bookingNumber !== '' && storedBookingNumber === bookingNumber);

	return isFlagEnabled && Boolean(isAdvanceDiagnosticsFlow) && belongsToBooking;
}
